module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-6e4934c3!./packages/dof-board/colmo.css
// module id = 501
// module chunks = 0 1